
const FAQ_FILTER_SELECTOR = '[data-faq-filter]'
const FAQ_QUESTION_SELECTOR = '[data-faq-question]'
const faqFilters = document.querySelectorAll(FAQ_FILTER_SELECTOR)
const faqQuestions = document.querySelectorAll(FAQ_QUESTION_SELECTOR)

function init() {

  if(faqFilters.length === 0 || faqQuestions.length === 0) return

  initQuestions(faqQuestions)
  initDisplayQuestions(faqFilters, faqQuestions)

}

function resetElementsAttribute(elements, attributeName){
  elements.forEach(element => {
    element.setAttribute(attributeName,'false')
  });
}

function initQuestions(questions) {

  openQuestion(questions);

}

function openQuestion(questions){

  questions.forEach(question => {
    question.addEventListener('click', (e) => {

      let isOpened = (question.getAttribute('aria-expanded') == 'true')

      if(isOpened){
        resetElementsAttribute(questions, "aria-expanded")
      }else{
        resetElementsAttribute(questions, "aria-expanded")
        setTimeout(() => {
          question.setAttribute('aria-expanded', 'true')
        }, 300)
      }

    })
  });
}

function initDisplayQuestions(faqFilters, faqQuestions) {

  displayFirstQuestionsOnLoad(faqFilters, faqQuestions)
  
  toggleQuestions(faqFilters, faqQuestions)

}

function displayFirstQuestionsOnLoad(filters, questions) {
  const firstFilter = filters[0]
  const firstFilterData = firstFilter.getAttribute('data-faq').toLowerCase()

  firstFilter.setAttribute('aria-expanded', 'true')

  questions.forEach(question => {
    
    const questionData = question.getAttribute('data-faq').toLowerCase()

    if(questionData === firstFilterData){
      question.setAttribute('aria-hidden', 'false')
    }

  });
}

function toggleQuestions(filters, questions) {

  let currentfilterData;
  let currentquestionData;

  filters.forEach(filter => {
    filter.addEventListener('click', (e) => {
      currentfilterData = filter.getAttribute('data-faq').toLowerCase()
      
      questions.forEach(question => {

        currentquestionData = question.getAttribute('data-faq').toLowerCase()

        if(currentquestionData === currentfilterData){
          question.setAttribute('aria-hidden', 'false')
        }else{
          question.setAttribute('aria-hidden', 'true')
        }
      });


    })
  });


}

export default { init }